export const getScheduledMaintenanceStatus = () => {
  const timeCurrent = new Date();
  const timeScheduledStart = new Date(process.env.REACT_APP_MAINTENANCE_SCHEDULED_START);
  const timeScheduledEnd = new Date(process.env.REACT_APP_MAINTENANCE_SCHEDULED_END);
  // Check if we have valid dates
  if (isNaN(timeScheduledStart.getTime()) || isNaN(timeScheduledEnd.getTime())) {
    return { isScheduled: false, isActive: false };
  }

  const isActive = timeCurrent >= timeScheduledStart && timeCurrent <= timeScheduledEnd;
  const isScheduled = timeScheduledEnd > timeCurrent;
  return {
    isScheduled,
    isActive,
    startTime: timeScheduledStart,
    endTime: timeScheduledEnd,
  };
};
const dateFormat = {
  month: 'long',
  day: 'numeric',
  year: 'numeric',
};
const timeFormat = {
  timeZoneName: 'shortGeneric',
  hour: 'numeric',
  minute: '2-digit',
};

export const convertToLocalDateString = (language, date) => {
  return date.toLocaleDateString(language, dateFormat);
};
export const convertToLocalTimeString = (language, date) => {
  return date.toLocaleTimeString(language, timeFormat);
};
